import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles({
    footerLinksContainer: {
        position: 'fixed',
        bottom: '12px',
        left: '12px',
        zIndex: 1000,
        fontSize: '11px',
        color: '#666',
        display: 'flex',
        gap: '12px'
    },
    footerLink: {
        color: '#666',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
});
export const CookieSettingsLink = ({ questionnaireName = '', themeName = '' }) => {
    const classes = useStyles();
    const handleCookieSettingsClick = (e) => {
        e.preventDefault();
        // Call Termly's displayPreferenceModal function if available
        if (typeof window.displayPreferenceModal === 'function') {
            window.displayPreferenceModal();
        }
        else {
            console.warn('Termly displayPreferenceModal function is not available');
        }
    };
    // Determine privacy policy URL based on questionnaire name or theme
    const getPrivacyPolicyUrl = () => {
        if (questionnaireName === 'Bord Gáis Solar Calculator' || themeName === 'Bord Gáis Theme') {
            return 'https://assets-us-01.kc-usercontent.com/7dd6b71d-d672-0004-6a4d-7043e1d0db33/47a3b574-c59d-4e58-bb57-adbb20fc9bd5/Swyft%20Energy%20Privacy%20Notice.pdf ';
        }
        return 'https://www.swyftenergy.ie/privacy-policy';
    };
    return (_jsxs("div", { className: classes.footerLinksContainer, children: [_jsx("a", { href: '#cookie-settings', onClick: handleCookieSettingsClick, className: classes.footerLink, "aria-label": 'Cookie Settings', children: "Cookie Settings" }), _jsx("a", { href: getPrivacyPolicyUrl(), target: '_blank', rel: 'noopener noreferrer', className: classes.footerLink, "aria-label": 'Privacy Policy', children: "Privacy Policy" })] }));
};
